import React, { useCallback } from 'react'
import classnames from 'classnames'
import { intl } from 'lang/intl'

import { TtIcon } from '@23/ui-react'

import { useMutingVideoConfirmation } from '../MutingWebcamConfirmComponent/MutingWebcamConfirmation'

import './MuteVideoTrigger.scss'

interface MuteVideoTriggerProps {
  isMuted: boolean
  toggleVideo: () => void
}

const MuteVideoTrigger = ({ isMuted, toggleVideo }: MuteVideoTriggerProps) => {
  const mutingVideoConfirmation = useMutingVideoConfirmation()

  let ariaLabel = intl.formatMessage({
    defaultMessage: 'Press enter or space to turn off your camera',
  })

  if (isMuted) {
    ariaLabel = intl.formatMessage({
      defaultMessage: 'Press enter or space to turn on your camera',
    })
  }

  const triggerMutingVideoConfirmation = useCallback(async () => {
    const confirmation = await mutingVideoConfirmation()
    if (confirmation) toggleVideo()
  }, [mutingVideoConfirmation, toggleVideo])

  return (
    <div
      className={classnames('mute-video-trigger-wrapper', {
        'video-disabled': isMuted,
      })}
    >
      <button
        type="button"
        className={classnames('mute-video-trigger', { muted: isMuted })}
        aria-label={ariaLabel}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()

          if (isMuted) {
            toggleVideo()
          } else {
            triggerMutingVideoConfirmation()
          }
        }}
      >
        <TtIcon
          library="one/webinars"
          name={isMuted ? 'camera-off' : 'camera-on'}
        />
      </button>
    </div>
  )
}

export { MuteVideoTrigger }
